import { Realty, services } from '@ambita/ambita-components-core';
import { ApiUnregisteredOwnership } from '../../../typings/Owner';

const util = services.util;

function transformUnregisteredOwnerships(unregisteredOwnershipsData: Realty.ApiResponse) {
  if (unregisteredOwnershipsData.items && unregisteredOwnershipsData.items.length > 0) {
    const unregisteredOwnerships: ApiUnregisteredOwnership[] = unregisteredOwnershipsData.items;
    const retObject: any = {
      unregisteredOwnerships: []
    };

    unregisteredOwnerships.forEach((unregisteredOwnership: ApiUnregisteredOwnership) => {
      const tmpObj: any = util.pick(unregisteredOwnership, [
        'cadastreLevel',
        'links'
      ]);
      if (unregisteredOwnership.fraction) {
        tmpObj.fraction =
          `${unregisteredOwnership.fraction.numerator} / ${unregisteredOwnership.fraction.denominator}`;
      } else {
        tmpObj.fraction = '0 / 0';
      }
      if (unregisteredOwnership.cadastreLevel) {
        tmpObj.cadastreLevel = unregisteredOwnership.cadastreLevel.text;
      }
      retObject.unregisteredOwnerships.push(tmpObj);
    });
    return retObject;
  }
}

export default transformUnregisteredOwnerships;
